import ANGLAIS from "../assets/images/app/iconMatiers/Anglais.png";
import FRANCAIS from "../assets/images/app/iconMatiers/Francais.png";
import HISTOIREGEO from "../assets/images/app/iconMatiers/Histoire-geo.png";
import MATH from "../assets/images/app/iconMatiers/Mathematiques.png";
import PHILO from "../assets/images/app/iconMatiers/Philosophie.png";
import PHYSIQUE from "../assets/images/app/iconMatiers/Physique-chimie.png";
import SVT from "../assets/images/app/iconMatiers/SVT.png";

import moment from "moment";
import belgiumFlag from "../assets/images/app/belgium-flag.png";
import frenchFlag from "../assets/images/app/french-flag.png";
import moroccoFlag from "../assets/images/app/morocco-flag.png";

import { useEffect } from "react";

import { Modal } from "antd";

export enum UserRoles {
  ADMIN = "admin",
  TEACHER = "teacher",
  STUDENT = "student",
  PARENT = "parent",
  ORGANISME = "organisme",
}

export enum AuthMethods {
  EMAIL = "email",
  GOOGLE = "google",
  FACEBOOK = "facebook",
}

export enum FLAGS {
  GROUP_FLAG = "GROUP_FLAG",
  SINGLE_FLAG = "SINGLE_FLAG",
}

export enum StatusCode {
  OK = 200,
  CREATED = 201,
  NO_CONTENT = 204,
  BAD_REQUEST = 400,
  UNAUTHORIZED = 401,
  FORBIDDEN = 403,
  NOT_FOUND = 404,
  INTERNAL_SERVER_ERROR = 500,
}

export enum HandlerInputError {
  title = "Le champ titre est requis",
  subtitles = "Le champ sous titre est requis",
  section = "Le champ section est requis",
  content = "Le champ contenu est requis",
  default = "Un champ n'a pas été renseigné",
}

export const enum CHOICE {
  SAVE_AS_DRAFT = "SAVE_AS_DRAFT",
  SAVE_PERMANENTLY = "SAVE_PERMANENTLY",
}
export enum Language {
  ENGLISH = "en",
  FRENCH = "fr",
}
export enum educSystem {
  BELGE = "Système Belge",
  FRENCH = "Système Français",
  MOROCCO = "Système Marocain",
}

export enum PlayLevel {
  EASY = "Facile",
  MEDIUM = "Moyen",
  HARD = "Difficile",
}

export enum TypeExercices {
  ApplicationsDeCours = "Applications de cours",
  Classiques = "Classiques",
  Annales = "Annales",
  Entraînement = "Entraînement",
}

export enum StatusEntity {
  PENDING = "PENDING",
  REJECTED = "REJECTED",
  PUBLISHED = "PUBLISHED",
  DRAFT = "DRAFT",
}
export const converterMoneyCommission = (montant: number) => {
  if (montant <= 1000) return montant - montant * 0.3;
  else {
    if (montant <= 5000) return montant - montant * 0.22;
    else {
      if (montant <= 15000) return montant - montant * 0.15;
      return montant - montant * 0.5;
    }
  }
};

export enum TypeMatiers {
  mathematique = "Mathematiques",
  PhysiqueChimie = "Physique-chimie",
  SVT = "SVT",
  Francais = "Francais",
  Anglais = "Anglais",
  HistoireGeo = "Histoire-geo",
  Philosophie = "Philosophie",
}

export enum TypeCours {
  mathematique = "Mathématiques",
  PhysiqueChimie = "Physique-chimie",
  SVT = "SVT",
  Francais = "Français",
  Anglais = "Anglais",
  HistoireGeo = "Histoire-géo",
  Philosophie = "Philosophie",
}

export const StepTitle = (current: number) => {
  if (current === 1) {
    return "À PROPOS";
  }
  else if (current === 2) {
    return "PHOTO DE PROFIL";
  }
  else if (current === 3) {
    return "FORMATION";
  }
  else if (current === 4) {
    return "CERTIFICATION D’ENSEIGNEMENT";
  }
  else if (current === 5) {
    return "DESCRIPTION DU PROFIL";
  }
  else if (current === 6) {
    return "VIDÉO DE PRÉSENTATION";
  }
  else if (current === 8) {
    return "PROGRAMME ET DISPONIBILITÉ";
  }
}

export const StepMessage = (current: number) => {
  if (current === 1) {
    return "Commence à créer ton profil public en tant que professeur ici! Tes modifications seront automatiquement enregistrées à mesure que tu complètes chaque section. Tu pourras y revenir à tout moment afin de finaliser ton inscription.";
  }
  else if (current === 2) {
    return "";
  }
  else if (current === 3) {
    return "Tu as obtenu des certifications ou des diplômes dans le domaine de l'enseignement ? Si oui, décris-les pour gagner en crédibilité et attirer plus d'élèves!";
  }
  else if (current === 4) {
    return "Dis-en plus aux élèves sur les diplômes de l'enseignement supérieur que tu as obtenus ou que tu prépares actuellement.";
  }
  else if (current === 5) {
    return "Crée ou mets à jour ton titre et une nouvelle description de ton profil. Ces éléments apparaîtront sur ton profil dans la page 'Trouver un professeur'.";
  }
  else if (current === 6) {
    return "";
  }
}

export enum StaticLevels {
  staticLeveId = "62e00770bbf0e80cf966552d",
}

export const Languages = (shortcode: string) => {
  if (shortcode === 'en') {
    return "Anglais";
  }
  if (shortcode === 'fr') {
    return "Français";
  }
}

export const currentStep = (step: string) => {
  if (step === "a_propos") {
    return 2;
  }
  else if (step === "photo") {
    return 3;
  }
  else if (step === "certificate") {
    return 4;
  }
  else if (step === "diploma") {
    return 5;
  }
  else if (step === "description") {
    return 6;
  }
  else if (step === "video") {
    return 7;
  }
  else if (step === "cost") {
    return 8;
  }
  else {
    return 1;
  }
}

export const setIcon = (course: string) => {
  if (course === "Mathématiques") {
    return MATH;
  }
  else if (course === "Physique-chimie") {
    return PHYSIQUE;
  }
  else if (course === "SVT") {
    return SVT;
  }
  else if (course === "Français") {
    return FRANCAIS;
  }
  else if (course === "Anglais") {
    return ANGLAIS;
  }
  else if (course === "Histoire-géo") {
    return HISTOIREGEO;
  }
  else if (course === "Philosophie") {
    return PHILO;
  }
  else {
    return ANGLAIS;
  }
}

export const setCourseName = (course: string) => {
  if (course === "Mathématiques") {
    return "Maths";
  }
  else if (course === "Physique-chimie") {
    return "Physique\nChimie";
  }
  else if (course === "SVT") {
    return SVT;
  }
  else if (course === "Français") {
    return "Français";
  }
  else if (course === "Anglais") {
    return "Anglais";
  }
  else if (course === "Histoire géo") {
    return "Histoire\nGeographie";
  }
  else if (course === "Philosophie") {
    return "Philo";
  }
}

export const setCountryFlag = (system: string) => {
  if (system === "Système Belge") {
    return belgiumFlag;
  }
  else if (system === "Système Français") {
    return frenchFlag;
  }
  else if (system === "Système Marocain") {
    return moroccoFlag;
  }
}

export const translateDayOfWeek = (day: string) => {
  if (day === "Monday") {
    return "Lundi";
  }
  if (day === "Tuesday") {
    return "Mardi";
  }
  if (day === "Wednestday") {
    return "Mercredi";
  }
  if (day === "Thursday") {
    return "Jeudi";
  }
  if (day === "Friday") {
    return "Vendredi";
  }
  if (day === "Saturday") {
    return "Samedi";
  }
  if (day === "Sunday") {
    return "Dimanche";
  }
}

export const teacherFaqData = [
  {
    "title": "Devenir Ami d’Albert",
    "data": [
      {
        "question": "Comment puis-je devenir professeur sur Mon Ami Albert?",
        "answer": "Pour enseigner sur Mon Ami Albert, vous devez avoir un diplôme ou qualification reconnus dans la matière que vous souhaitez enseigner ainsi qu'une expérience pertinente. Un processus de vérification et un entretien en ligne sont également requis pour valider votre expertise."
      },
      {
        "question": "Comment puis-je rendre mon profil plus attractif pour les élèves?",
        "answer": "Pour rendre votre profil plus attractif, assurez-vous d'inclure une biographie détaillée mettant en avant votre expérience et vos méthodes d'enseignement. Choisir une photo professionnelle ainsi qu'une vidéo de présentation pédagogue contribuera également à booster l'attractivité de votre profil. Enfin, recueillir des avis positifs de la part de vos élèves précédents augmentera votre visibilité et votre attractivité sur la plateforme."
      },
      {
        "question": "Est-il possible de mettre mon profil en pause?",
        "answer": "Oui, si vous devez prendre une pause pour quelque raison que ce soit, vous pouvez temporairement désactiver votre profil. Votre profil ne sera pas visible pour les nouveaux élèves pendant cette période, mais vous pourrez le réactiver à tout moment.<br/> Toutefois, conformément à notre système de gain de points lié à votre participation active sur la plateforme, tout mois d'inactivité vous 'coûte' des points... et donc l'opportunité de générer davantage de revenus sur notre plateforme! C'est dommage.<br/> Pour connaître le détail du système de gain de points, connectez-vous à votre compte Prof et cliquez ici."
      },
    ],
  },
  {
    "title": "Gestion du Profil",
    "data": [
      {
        "question": "Comment puis-je mettre à jour mon profil de professeur?",
        "answer": "Connectez-vous à votre compte et accédez à la section 'Profil'. Ici, vous pouvez mettre à jour vos informations personnelles, ajouter des diplômes ou qualifications, modifier votre photo de profil et ajuster votre bio pour mieux refléter votre expertise et vos méthodes d'enseignement."
      },
      {
        "question": "Comment puis-je ajouter de nouveaux niveaux et/ou matières à mon offre d'enseignement?",
        "answer": "Pour ajouter un nouveau cours, connectez-vous à votre espace Prof, sélectionnez l'option 'Modifier mon profil', allez sur 'Tarifs' et suivez les instructions pour ajouter le niveau et/ou la matière ainsi que d'autres détails sur votre offre.."
      },
    ],
  },
  {
    "title": "Planification des Cours",
    "data": [
      {
        "question": "",
        "answer": ""
      },
    ],
  },
  {
    "title": "Paiements et Rémunération",
    "data": [
      {
        "question": "",
        "answer": ""
      },
    ],
  },
  {
    "title": "InstaProf",
    "data": [
      {
        "question": "",
        "answer": ""
      },
    ],
  },
  {
    "title": "Assistance Technique",
    "data": [
      {
        "question": "",
        "answer": ""
      },
    ],
  }
];

export const studentFaqData = [
  {
    "title": "Inscription et Connexion",
    "data": [
      {
        "question": "Comment puis-je créer un compte sur Mon Ami Albert?",
        "answer": "C'est très simple! Visitez notre site internet, cliquez sur 'S´inscrire', et suivez les instructions pour compléter votre inscription. Vous pouvez également simplement cliquer ici."
      },
      {
        "question": "Comment puis-je réinitialiser mon mot de passe si je l'oublie?",
        "answer": "Sur la page de connexion, cliquez sur 'Mot de passe oublié?' et suivez les instructions pour réinitialiser votre mot de passe via votre adresse email."
      },
      {
        "question": "Puis-je changer mon adresse email après l'inscription?",
        "answer": "Oui, vous pouvez changer votre adresse email depuis les paramètres de votre compte. Assurez-vous de confirmer le changement via un email de vérification que nous vous enverrons."
      },
    ],
  },
  {
    "title": "Utilisation de la Plateforme",
    "data": [
      {
        "question": "",
        "answer": ""
      },
      {
        "question": "",
        "answer": ""
      },
    ],
  },
  {
    "title": "Réservation, déroulement, paiement et annulation de cours",
    "data": [
      {
        "question": "",
        "answer": ""
      },
    ],
  },
  {
    "title": "InstaProf",
    "data": [
      {
        "question": "",
        "answer": ""
      },
    ],
  },
  {
    "title": "Suivi des Progrès",
    "data": [
      {
        "question": "",
        "answer": ""
      },
    ],
  },
  {
    "title": "Assistance Technique",
    "data": [
      {
        "question": "",
        "answer": ""
      },
    ],
  },
  {
    "title": "Sécurité et Confidentialité",
    "data": [
      {
        "question": "",
        "answer": ""
      },
    ],
  }
];

export const parentFaqData = [
  {
    "title": "Création de Compte",
    "data": [
      {
        "question": "Comment puis-je créer un compte parent sur Mon Ami Albert?",
        "answer": "Pour créer un compte Parent, visitez notre site web et cliquez sur l'option d'inscription en tant que 'Parent'. Suivez les instructions pour remplir les informations nécessaires et activer votre compte."
      },
    ],
  },
  {
    "title": "Inviter votre Enfant",
    "data": [
      {
        "question": "Comment puis-je inscrire mon enfant sur la plateforme?",
        "answer": "Pour ajouter votre enfant à la plateforme, connectez-vous à votre compte Parent et cliquez sur l'option 'Ajouter des élèves'. Suivez ensuite les instructions pour compléter l'inscription de votre enfant."
      },
    ],
  },
  {
    "title": "Suivi de l'Enfant",
    "data": [
      {
        "question": "Comment puis-je suivre les progrès de mon enfant sur la plateforme?",
        "answer": "Vous pouvez suivre les progrès de votre enfant en vous connectant à votre compte Parent et en accédant au tableau de bord dédié. Ce tableau affiche les cours suivis, les notes obtenues, et d'autres indicateurs de performance."
      },
    ],
  },
  {
    "title": "Paiement des Cours",
    "data": [
      {
        "question": "Comment puis-je payer pour les cours de mon enfant?",
        "answer": "Les paiements pour les cours peuvent être effectués via votre compte Parent. Ajoutez une méthode de paiement et suivez les instructions pour recharger le portefeuille de votre enfant et régler les frais des cours sélectionnés."
      },
    ],
  },
  {
    "title": "Communication avec Enseignants",
    "data": [
      {
        "question": "Est-il possible de communiquer directement avec les professeur de mon enfant?",
        "answer": "Il est tout à fait possible pour vous d'échanger avec les enseignants de votre enfant à travers la fonction Messagerie sur le plateforme."
      },
    ],
  },
];

export const organisationFaqData = [
  {
    "title": "Partenariats",
    "data": [
      {
        "question": "Comment notre organisation peut-elle devenir partenaire de Mon Ami Albert?",
        "answer": "Pour explorer les possibilités de partenariat avec Mon Ami Albert, veuillez contacter notre équipe de développement des partenariats à l'adresse partenariat@monamialbert.com. Nous discuterons des options qui peuvent inclure des collaborations sur des programmes éducatifs, des projets de recherche, ou d'autres initiatives."
      },
      {
        "question": "Quelles sont les différentes manières pour notre organisme de collaborer avec Mon Ami Albert?",
        "answer": "Nous sommes ouverts et ravis de discuter afin de co-créer une collaboration fructueuse et enrichissante ensemble. Nous vous invitons à contacter notre équipe de développement de partenariats à l'adresse partnerships@monamialbert.com. "
      },
    ],
  },
  {
    "title": "Utilisation de la Plateforme",
    "data": [
      {
        "question": "Comment notre organisme peut-il utiliser la plateforme pour ses membres?",
        "answer": "Mon Ami Albert offre des solutions personnalisées pour les organismes ou fondations qui souhaitent fournir un accès éducatif à leurs membres. Vous pouvez créer un compte Organisme et nous pouvons configurer des accès groupés selon vos besoins spécifiques."
      },
    ],
  },
  {
    "title": "Rapports et Analyses",
    "data": [
      {
        "question": "Fournissez-vous des rapports sur l'utilisation de la plateforme par notre organisme?",
        "answer": "Oui, nous fournissons des rapports détaillés qui peuvent aider votre organisme à suivre l'engagement et les progrès de vos membres."
      },
    ],
  },
];

export const albertFaqData = [
  {
    "title": "MonAmiAlbert",
    "data": [
      {
        "question": "Mon Ami Albert, c'est quoi?",
        "answer": "Mon Ami Albert est une plateforme éducative en ligne dédiée à l'amélioration de l'apprentissage des élèves, du niveau collège à la classe prépa. Notre mission est d'offrir un accès facile, direct et flexible à des cours de soutien académique de qualité, à des ressources éducatives innovantes et à une assistance personnalisée. Chez Mon ami Albert, nous mettons en contact des élèves motivés avec des professeurs expérimentés à travers des sessions en ligne interactives adaptées aux besoins et aux rythmes de chacun. Que ce soit pour des révisions, l’apprentissage de nouvelles compétences ou la préparation à des examens, Mon Ami Albert s'engage à offrir une expérience éducative bénéfique, enrichissante et accessible à tous."
      },
      {
        "question": "Quels sont les services offerts par Mon Ami Albert?",
        "answer": "Mon Ami Albert offre une gamme variée de services éducatifs destinés à répondre aux différents besoins d’apprentissage et de consolidation des acquis des élèves : 1. Cours en ligne personnalisés : des sessions individuelles et/ou collectives avec des profs qualifiés;"
      },
    ],
  },
];

export const isToday = (someDate: string) => {
  const today = new Date();
  const givenDate = new Date(someDate);
  return (
    givenDate.getDate() === today.getDate() &&
    givenDate.getMonth() === today.getMonth() &&
    givenDate.getFullYear() === today.getFullYear()
  );
};

export const calculateAvg = (application: any, excercise: any, courses: any) => {
  if (application !== 0 && excercise !== 0 && courses !== 0) {
    const note = application + excercise + courses;
    const avg = note / 3;
    return avg.toFixed(2);
  }
  else {
    return 0;
  }
}

export function calculateTimeDifference(start: string, end: string): string {
  const [startHours, startMinutes] = start.split(":").map(Number);
  const [endHours, endMinutes] = end.split(":").map(Number);

  // Create Date objects
  const startTime = new Date(0, 0, 0, startHours, startMinutes);
  const endTime = new Date(0, 0, 0, endHours, endMinutes);

  // Calculate difference in milliseconds
  const diff = endTime.getTime() - startTime.getTime();

  // Convert to hours and minutes
  const diffHours = Math.floor(diff / (1000 * 60 * 60));
  const diffMinutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));

  if (diffHours !== 0 && diffMinutes === 0) {
    return `${diffHours} h`;
  }
  else if (diffHours === 0 && diffMinutes !== 0) {
    return `${diffMinutes} mins`;
  }
  else {
    return `${diffHours} h ${diffMinutes}`;
  }
}

export const getCountryCode = (country: any) => {

  const countriesList = [
    { name: "Afghanistan", code: "AF" },
    { name: "Afrique du Sud", code: "ZA" },
    { name: "Albanie", code: "AL" },
    { name: "Algérie", code: "DZ" },
    { name: "Allemagne", code: "DE" },
    { name: "Andorre", code: "AD" },
    { name: "Angola", code: "AO" },
    { name: "Arabie saoudite", code: "SA" },
    { name: "Argentine", code: "AR" },
    { name: "Arménie", code: "AM" },
    { name: "Australie", code: "AU" },
    { name: "Autriche", code: "AT" },
    { name: "Azerbaïdjan", code: "AZ" },
    { name: "Belgique", code: "BE" },
    { name: "Bénin", code: "BJ" },
    { name: "Bhoutan", code: "BT" },
    { name: "Biélorussie", code: "BY" },
    { name: "Birmanie", code: "MM" },
    { name: "Bolivie", code: "BO" },
    { name: "Bosnie-Herzégovine", code: "BA" },
    { name: "Botswana", code: "BW" },
    { name: "Brésil", code: "BR" },
    { name: "Bulgarie", code: "BG" },
    { name: "Burkina Faso", code: "BF" },
    { name: "Burundi", code: "BI" },
    { name: "Cameroun", code: "CM" },
    { name: "Canada", code: "CA" },
    { name: "Cap-Vert", code: "CV" },
    { name: "Chili", code: "CL" },
    { name: "Chine", code: "CN" },
    { name: "Chypre", code: "CY" },
    { name: "Colombie", code: "CO" },
    { name: "Comores", code: "KM" },
    { name: "Congo-Brazzaville", code: "CG" },
    { name: "Congo-Kinshasa", code: "CD" },
    { name: "Corée du Nord", code: "KP" },
    { name: "Corée du Sud", code: "KR" },
    { name: "Costa Rica", code: "CR" },
    { name: "Côte d'Ivoire", code: "CI" },
    { name: "Croatie", code: "HR" },
    { name: "Cuba", code: "CU" },
    { name: "Danemark", code: "DK" },
    { name: "Djibouti", code: "DJ" },
    { name: "Dominique", code: "DM" },
    { name: "Égypte", code: "EG" },
    { name: "Émirats arabes unis", code: "AE" },
    { name: "Équateur", code: "EC" },
    { name: "Érythrée", code: "ER" },
    { name: "Espagne", code: "ES" },
    { name: "Estonie", code: "EE" },
    { name: "États-Unis", code: "US" },
    { name: "Eswatini", code: "SZ" },
    { name: "Éthiopie", code: "ET" },
    { name: "Fidji", code: "FJ" },
    { name: "Finlande", code: "FI" },
    { name: "France", code: "FR" },
    { name: "Gabon", code: "GA" },
    { name: "Gambie", code: "GM" },
    { name: "Géorgie", code: "GE" },
    { name: "Ghana", code: "GH" },
    { name: "Grèce", code: "GR" },
    { name: "Guatemala", code: "GT" },
    { name: "Guinée", code: "GN" },
    { name: "Guinée-Bissau", code: "GW" },
    { name: "Guinée équatoriale", code: "GQ" },
    { name: "Haïti", code: "HT" },
    { name: "Honduras", code: "HN" },
    { name: "Hongrie", code: "HU" },
    { name: "Inde", code: "IN" },
    { name: "Indonésie", code: "ID" },
    { name: "Irak", code: "IQ" },
    { name: "Iran", code: "IR" },
    { name: "Irlande", code: "IE" },
    { name: "Islande", code: "IS" },
    { name: "Israël", code: "IL" },
    { name: "Italie", code: "IT" },
    { name: "Japon", code: "JP" },
    { name: "Jordanie", code: "JO" },
    { name: "Kazakhstan", code: "KZ" },
    { name: "Kenya", code: "KE" },
    { name: "Kirghizistan", code: "KG" },
    { name: "Kiribati", code: "KI" },
    { name: "Koweït", code: "KW" },
    { name: "Laos", code: "LA" },
    { name: "Lesotho", code: "LS" },
    { name: "Lettonie", code: "LV" },
    { name: "Liban", code: "LB" },
    { name: "Libéria", code: "LR" },
    { name: "Libye", code: "LY" },
    { name: "Liechtenstein", code: "LI" },
    { name: "Lituanie", code: "LT" },
    { name: "Luxembourg", code: "LU" },
    { name: "Madagascar", code: "MG" },
    { name: "Malaisie", code: "MY" },
    { name: "Malawi", code: "MW" },
    { name: "Maldives", code: "MV" },
    { name: "Mali", code: "ML" },
    { name: "Malte", code: "MT" },
    { name: "Maroc", code: "MA" },
    { name: "Maurice", code: "MU" },
    { name: "Mauritanie", code: "MR" },
    { name: "Mexique", code: "MX" },
    { name: "Moldavie", code: "MD" },
    { name: "Monaco", code: "MC" },
    { name: "Mongolie", code: "MN" },
    { name: "Mozambique", code: "MZ" },
    { name: "Namibie", code: "NA" },
    { name: "Népal", code: "NP" },
    { name: "Nicaragua", code: "NI" },
    { name: "Niger", code: "NE" },
    { name: "Nigeria", code: "NG" },
    { name: "Norvège", code: "NO" },
    { name: "Nouvelle-Zélande", code: "NZ" },
    { name: "Oman", code: "OM" },
    { name: "Ouganda", code: "UG" },
    { name: "Ouzbékistan", code: "UZ" },
    { name: "Pakistan", code: "PK" },
    { name: "Palaos", code: "PW" },
    { name: "Palestine", code: "PS" },
    { name: "Panama", code: "PA" },
    { name: "Papouasie-Nouvelle-Guinée", code: "PG" },
    { name: "Paraguay", code: "PY" },
    { name: "Pays-Bas", code: "NL" },
    { name: "Pérou", code: "PE" },
    { name: "Philippines", code: "PH" },
    { name: "Pologne", code: "PL" },
    { name: "Portugal", code: "PT" },
    { name: "Qatar", code: "QA" },
    { name: "République centrafricaine", code: "CF" },
    { name: "République tchèque", code: "CZ" },
    { name: "Roumanie", code: "RO" },
    { name: "Royaume-Uni", code: "GB" },
    { name: "Russie", code: "RU" },
    { name: "Rwanda", code: "RW" },
    { name: "Sénégal", code: "SN" },
    { name: "Serbie", code: "RS" },
    { name: "Seychelles", code: "SC" },
    { name: "Sierra Leone", code: "SL" },
    { name: "Singapour", code: "SG" },
    { name: "Slovaquie", code: "SK" },
    { name: "Slovénie", code: "SI" },
    { name: "Somalie", code: "SO" },
    { name: "Soudan", code: "SD" },
    { name: "Sri Lanka", code: "LK" },
    { name: "Suède", code: "SE" },
    { name: "Suisse", code: "CH" },
    { name: "Suriname", code: "SR" },
    { name: "Syrie", code: "SY" },
    { name: "Tadjikistan", code: "TJ" },
    { name: "Tanzanie", code: "TZ" },
    { name: "Tchad", code: "TD" },
    { name: "Thaïlande", code: "TH" },
    { name: "Togo", code: "TG" },
    { name: "Tunisie", code: "TN" },
    { name: "Turquie", code: "TR" },
    { name: "Ukraine", code: "UA" },
    { name: "Uruguay", code: "UY" },
    { name: "Vatican", code: "VA" },
    { name: "Venezuela", code: "VE" },
    { name: "Viêt Nam", code: "VN" },
    { name: "Yémen", code: "YE" },
    { name: "Zambie", code: "ZM" },
    { name: "Zimbabwe", code: "ZW" }
  ];

  const countryData = countriesList.find((data: any) => data.name === country);
  return countryData?.code;

}

export const removeDuplicates = (array: any[]) => {
  const seen = new Set();
  if (array) {
    const uniqueItems = array.filter((item: any) => {
      if (!item.price) return false; // Remove elements with empty price
      const key = `${item.levelGroup}-${item.price}`;
      if (seen.has(key)) {
        return false; // Skip duplicate
      }
      seen.add(key);
      return true; // Keep unique
    });

    // Now sort by the first letter of `levelGroup`
    return uniqueItems.sort((a: any, b: any) => {
      const firstA = a.levelGroup?.[0]?.toLowerCase() || '';
      const firstB = b.levelGroup?.[0]?.toLowerCase() || '';
      return firstA.localeCompare(firstB);
    });
  }
  return [];
};

export const removeDuplicatesTopics = (data: any[]) => {
  const uniqueTopics = Array.from(
    new Set(
      data
        .filter(item => item && item.title)
        .map(item => item.title)
    )
  ).sort();
  return uniqueTopics;
};

export const removeDuplicatesTopicsLength = (data: any[]) => {
  const uniqueTopics = Array.from(
    new Set(
      data
        .filter(item => item && item.title)
        .map(item => item.title)
    )
  ).sort();
  return uniqueTopics.length;
};

export const removeDuplicatesLevels = (data: any[]) => {
  const uniqueLevelGroups = Array.from(
    new Set(data.map(item => item.levelGroup))
  ).sort();
  return uniqueLevelGroups;
};

export const removeDuplicatesLevelsLength = (data: any[]) => {
  const uniqueLevelGroups = Array.from(
    new Set(data.map(item => item.levelGroup))
  ).sort();
  return uniqueLevelGroups.length;
};

export const formatFrenchDate = (dateString: string): string => {
  // Explicitly parse the date with a given format
  const parsedDate = moment(dateString);

  // Check if the date is valid
  if (!parsedDate.isValid()) {
    throw new Error('Invalid date format. Expected DD-MM-YYYY.');
  }

  // Format the date in French
  return parsedDate.locale('fr').format('dddd D MMMM YYYY');
};

export function truncateWithoutBreakingWord(html: string, maxLength: number): string {
  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = html;

  const text = tempDiv.textContent || tempDiv.innerText || "";

  if (text.length <= maxLength) return text;

  const trimmed = text.slice(0, maxLength);
  const lastSpaceIndex = trimmed.lastIndexOf(" ");

  return trimmed.slice(0, lastSpaceIndex) + "...";
}

export function getTimeZonesByCountryCode(countryCode: any) {
  const zones = moment.tz.zonesForCountry(countryCode);
  if (!zones || zones.length === 0) return null;

  const tz = zones[0];
  const now = moment().tz(tz).format("HH:mm");
  const offset = moment().tz(tz).format("Z");

  return `${now} (UTC${offset}) - ${tz}`;
}

export const studentsTestimonies = [
  { firstname: "Sarah", lastname: "Bettach", level: "Terminale", testimony: "C’est utile et efficace." },
  { firstname: "Ali", lastname: "Kocak", level: "Terminale", testimony: "Mon Ami Albert offre un très bon accompagnement pour progresser dans une matière dans laquelle tu as des lacunes." },
  { firstname: "Hiba", lastname: "Alkhaddari", level: "Prépa ECG", testimony: "Mon professeur était sérieux et pédagogue." },
  { firstname: "Rhayane", lastname: "Wirdane", level: "Première", testimony: "Mon Ami Albert offre un accompagnement rigoureux et personnalisé. Les tuteurs sont compétents, investis, et ça se ressent dans les progrès concrets que j’ai faits." },
  { firstname: "Emmanuel", lastname: "Ratsimba", level: "Première", testimony: "Facilité du site internet, réactivité de l'assistance, professeurs de qualité." },
  { firstname: "Ibrahim", lastname: "Saoudati", level: "Licence", testimony: "Cette plateforme est excellente!" },
  { firstname: "Bianca", lastname: "Ursu", level: "Terminale", testimony: "Tu va réussir avec eux! Mes notes en physiques ont augmenté de 5 points en moyenne. Je recommande Mon Ami Albert." },
  { firstname: "Rime", lastname: "Dahmane", level: "Terminale", testimony: "Je suis ravie d’avoir eu cet accompagnement. Ma tutrice a été adorable et a su s’adapter à mes besoins." },
  { firstname: "Efe", lastname: "Bulut", level: "Première", testimony: "C'est une organisation qui est facile d'accès et très disponible. Ils te trouvent des tuteurs très rapidement. Les tuteurs sont bienveillants et à l'écoute, leurs méthodes pédagogiques sont simples et concrètes. Elles aident vraiment à s'améliorer dans la matière désignée. Mes notes en maths ont augmenté de 4 points en moyenne. Et les tuteurs sont disponibles." },
  { firstname: "Adam Ait", lastname: "Messaoud", level: "Terminale", testimony: "Les accompagnements changent de l’enseignement que l’on connaît en classe, cela peut nous permettre de s’améliorer grâce à une approche et des méthodologies différentes." },
  { firstname: "Mathis", lastname: "Pailliez", level: "Terminale", testimony: "C'est une organisation qui permet de s'améliorer facilement dans des matières où l'on a des lacunes ou si l'on souhaite se perfectionner ! La qualité des tuteurs permet de mettre cet enseignement presque à la même hauteur que ceux en présentiel et permet un soutien parfois indispensable dans certains cours." },
  { firstname: "Mina", lastname: "Levesque", level: "Première", testimony: "Ce sont des cours qui te redonneront confiance en toi tout en t'accompagnant dans la bienveillance. Mes notes en maths ont augmenté de 6 points en moyenne." },
  { firstname: "Kheira", lastname: "Mechta", level: "Première", testimony: "Ces cours m'ont permis d’avoir de très bonnes notes! Mes notes en maths ont augmenté de 4 points en moyenne. Je recommande." },
  { firstname: "Lorena", lastname: "Milleville", level: "Licence", testimony: "Je recommande. C'était pédagogique. Le professeur était bienveillant, ce qui m'a permis d'améliorer mes compétences en anglais." },
  { firstname: "Julie", lastname: "Guenier", level: "Terminale", testimony: "C’est une bonne opportunité d’améliorer son niveau dans certaines matières. Ca m’a permis de comprendre plus précisément la source de mes lacunes." },
  { firstname: "Nirmine", lastname: "Fkih", level: "Licence", testimony: "Fonce !! J’ai eu l’occasion d’avoir un tuteur disponible, pédagogue, sympathique, honnête et j’en passe. C’était génial !! J’avais un peu peur du jugement mais pas du tout !! Tu peux lui poser toutes tes questions, tes incompréhensions, etc. Mes notes en maths ont augmenté de 4 points en moyenne. Bref, vas-y les yeux fermés !" },
  { firstname: "Chezka-Nicole", lastname: "Sampang", level: "Seconde", testimony: "Les cours sont bien et les tuteurs sont très gentils et motivés." },
  { firstname: "Noah", lastname: "Pidoux", level: "Première", testimony: "C'est très efficace! Mes notes en SVT ont augmenté de 3 points en moyenne. Je recommande." },
  { firstname: "Thaïs", lastname: "Petit", level: "Première", testimony: "Cela a été bénéfique pour moi, notamment pour la compréhension des exercices demandés en évaluation. Le tuteur est disponible et assez flexible sur les horaires et les dates; il s’est toujours adapté à moi. Je recommande les cours avec Mon Ami Albert." },
  { firstname: "Ihssane", lastname: "El Morabet", level: "Terminale", testimony: "Les cours en distanciel permettent de gagner du temps. Le tuteur est disponible pour nous et s’adapte bien à nos demandes. Il possède un bon niveau de maîtrise. Mes notes en physiques ont augmenté de 4 points en moyenne. Je recommande!" },
  { firstname: "Yassin", lastname: "El Kdim", level: "Terminale", testimony: "Équipe disponible, bienveillante et aux soins de la réussite de chacun." },
  { firstname: "Léa", lastname: "Billy", level: "Terminale", testimony: "C'est un bon moyen de renforcer ses acquis. Les méthodes et les supports sont variés. Les tuteurs sont à l'écoute et proposent diverses approches." },
  { firstname: "Rannia", lastname: "Megrouh", level: "Terminale", testimony: "Vous serez bien encadrés, entendus et les cours seront adaptés à vos besoins. Je recommande!" },
  { firstname: "Jacques", lastname: "Jiao", level: "Première", testimony: "C'est une bonne expérience à vivre. Je recommande! Mes notes d'anglais ont augmenté de 5 points grâce à mes cours." },
  { firstname: "Benoit", lastname: "Dupont", level: "Terminale", testimony: "L’équipe d’accompagnement est top! Je recommande Mon Ami Albert." },
  { firstname: "Elisa", lastname: "Djamalkhanova", level: "Terminale", testimony: "Mon Ami Albert et son équipe sont super efficaces et il est facile de communiquer avec son tuteur! Je recommande." },
  { firstname: "Zvart", lastname: "Rostomyan", level: "Licence", testimony: "L'équipe Mon Ami Albert m’a aidé en me mettant en contact avec un tuteur dans un délai très court. Ils ont été soucieux des compétences et de la pédagogie du tuteur, ce qui m’a permis de bénéficier d’un accompagnement de qualité. De plus, leur implication dans le bon déroulement des cours ainsi que l’organisation de ces derniers ont été remarquables. Je recommande!" },
  { firstname: "Anjalina", lastname: "Saad", level: "Terminale", testimony: "C’est une occasion pour s’améliorer en mathématiques dans une ambiance agréable ET propice au travail." },
  { firstname: "Hadjer", lastname: "Bouziani", level: "Première", testimony: "En tant qu’élève de Première Générale passant en Terminale l’année prochaine, si je devais conseiller un ou une amie, je lui dirais de s’inscrire sur Mon Ami Albert sans hésiter. Les cours sont très bien faits, il est possible de choisir les chapitres en fonction de ses difficultés, et de manifester ses préférences quant au format des cours. De plus, c’est une solution prouvée et approuvée par de nombreux élèves, ce qui peut donc rassurer les parents, souvent inquiets à l’idée de ne pas trouver les bons cours ou les bons tuteurs pour leurs enfants. Merci ! " },
  { firstname: "Mariam", lastname: "Cisse Ndeye", level: "Première", testimony: "Les tuteurs et équipe de Mon Ami Albert sont très ponctuels et efficaces, et également très professionnels et attentifs. Je recommande!" },
  { firstname: "Nasri", lastname: "Bourhane", level: "Première", testimony: "Mon Ami Albert est une très bonne plateforme éducative qui offre d'excellents cours de soutiens avec de très bons professeurs à disposition. De mon côté, mon professeur a été à l'écoute, on n'avait pas de besoin d'avoir tel ou tel niveau dans telle matière pour pouvoir commencer et mon professeur n'attendait pas forcément un rythme de travail élevé; il s'adaptait à ma vitesse d'apprentissage. Je recommande!" },
];

export const studentTestimonies = [
  { firstname: "Efe", lastname: "Bulut", level: "Première", testimony: "C'est une organisation qui est facile d'accès et très disponible. Ils te trouvent des tuteurs très rapidement. Les tuteurs sont bienveillants et à l'écoute, leurs méthodes pédagogiques sont simples et concrètes. Elles aident vraiment à s'améliorer dans la matière désignée. Mes notes en maths ont augmenté de 4 points en moyenne. Et les tuteurs sont disponibles." },
  { firstname: "Adam Ait", lastname: "Messaoud", level: "Terminale", testimony: "Les accompagnements changent de l’enseignement que l’on connaît en classe, cela peut nous permettre de s’améliorer grâce à une approche et des méthodologies différentes." },
  { firstname: "Mathis", lastname: "Pailliez", level: "Terminale", testimony: "C'est une organisation qui permet de s'améliorer facilement dans des matières où l'on a des lacunes ou si l'on souhaite se perfectionner ! La qualité des tuteurs permet de mettre cet enseignement presque à la même hauteur que ceux en présentiel et permet un soutien parfois indispensable dans certains cours." },
  { firstname: "Mina", lastname: "Levesque", level: "Première", testimony: "Ce sont des cours qui te redonneront confiance en toi tout en t'accompagnant dans la bienveillance. Mes notes en maths ont augmenté de 6 points en moyenne." },
  { firstname: "Kheira", lastname: "Mechta", level: "Première", testimony: "Ces cours m'ont permis d’avoir de très bonnes notes! Mes notes en maths ont augmenté de 4 points en moyenne. Je recommande." },
  { firstname: "Lorena", lastname: "Milleville", level: "Licence", testimony: "Je recommande. C'était pédagogique. Le professeur était bienveillant, ce qui m'a permis d'améliorer mes compétences en anglais." },
];

export function useBackForwardHandler(isSearching: boolean, onCancel?: () => void) {
  useEffect(() => {
    const handlePopState = () => {
      if (isSearching) {
        // Show your custom confirm dialog
        Modal.warn({
          title: "Instaprof en cours",
          content: "Merci d'arrêter la recherche avant de quitter.",
          okText: "Fermer",
          onOk: () => {
            onCancel?.();
            // Push user back to prevent navigation
            window.history.pushState(null, "", window.location.pathname);
          },
        });
      }
    };

    // Add dummy state so back button is trapped
    if (isSearching) {
      window.history.pushState(null, "", window.location.pathname);
      window.addEventListener("popstate", handlePopState);
    }

    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, [isSearching, onCancel]);
}

export function formatDates(data: Date) {
  const date = new Date(data);
  const formatted = date.toLocaleDateString("fr-FR", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
  return formatted;
}

export const formatDate = (isoDate: string) => {
  const date = new Date(isoDate);
  const formatted = new Intl.DateTimeFormat("fr-FR", {
    day: "numeric",
    month: "long",
    year: "numeric",
  }).format(date);

  return formatted;
};

export const formatCreditDate = (date: string) => {
  const [year, month, day] = date?.split("-");
  return `${day}-${month}-${year}`;
};

interface GamificationRule {
  _id: string;
  description: string;
  isActive: boolean;
  ruleType: 'bonus' | 'malus' | 'reservation';
  userType: string;
  eventType: string;
  albertHead: string;
  notifType: string;
  points: number;
  message: string;
  title: string;
  code: string;
  createdAt: string;
  updatedAt: string;
  __v: number;
}

interface SeparatedAndGrouped {
  bonus?: Record<string, GamificationRule[]>;
  malus?: Record<string, GamificationRule[]>;
  reservation?: Record<string, GamificationRule[]>;
}

export function separateThenGroup(data: GamificationRule[]): SeparatedAndGrouped {
  // Step 1: Separate by ruleType
  const bonus = data.filter(item => item.ruleType === 'bonus');
  const malus = data.filter(item => item.ruleType === 'malus');
  const reservation = data.filter(item => item.ruleType === 'reservation');

  // Step 2: Group each by title
  const groupByTitle = (items: GamificationRule[]) => {
    return items.reduce((acc, item) => {
      const title = item.title;
      if (!acc[title]) {
        acc[title] = [];
      }
      acc[title].push(item);
      return acc;
    }, {} as Record<string, GamificationRule[]>);
  };

  return {
    bonus: groupByTitle(bonus),
    malus: groupByTitle(malus),
    reservation: groupByTitle(reservation),
  };
}

export const getFirebaseErrorMessage = (errorCode: string): string => {
  const errorMessages: { [key: string]: string } = {
    'auth/invalid-phone-number': 'Le numéro de téléphone est invalide. Veuillez vérifier le format.',
    'auth/missing-phone-number': 'Veuillez fournir un numéro de téléphone.',
    'auth/quota-exceeded': 'Le quota de SMS a été dépassé. Veuillez réessayer plus tard.',
    'auth/user-disabled': 'Ce compte utilisateur a été désactivé.',
    'auth/operation-not-allowed': 'L\'authentification par téléphone n\'est pas activée.',
    'auth/captcha-check-failed': 'La vérification reCAPTCHA a échoué. Veuillez réessayer.',
    'auth/invalid-app-credential': 'La vérification reCAPTCHA est invalide. Veuillez rafraîchir la page.',
    'auth/too-many-requests': 'Trop de tentatives. Votre accès a été temporairement bloqué. Veuillez réessayer plus tard.',
    'auth/network-request-failed': 'Erreur de connexion réseau. Veuillez vérifier votre connexion internet.',
    'auth/internal-error': 'Une erreur interne s\'est produite. Veuillez réessayer.',
    'auth/invalid-verification-code': 'Le code de vérification est invalide.',
    'auth/code-expired': 'Le code de vérification a expiré. Veuillez demander un nouveau code.',
    'auth/invalid-verification-id': 'L\'identifiant de vérification est invalide.',
    'auth/missing-verification-code': 'Veuillez saisir le code de vérification.',
    'auth/session-expired': 'La session a expiré. Veuillez recommencer.',
    'auth/web-storage-unsupported': 'Le stockage web n\'est pas supporté ou a été désactivé.',
    'auth/unverified-email': 'L\'adresse e-mail n\'a pas été vérifiée.',
  };

  return errorMessages[errorCode] || 'Une erreur est survenue. Veuillez réessayer.';
};
